import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinmumbai() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Mumbai',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Mumbai',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Corporate Cab Services in Mumbai, meeting the transportation needs of corporate offices, business parks, and industrial hubs across the city. Our fleet of executive sedans, SUVs, and premium vehicles ensures comfortable, safe, and timely travel for employees, clients, and senior management. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver smooth and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a seamless and premium corporate travel experience for businesses operating in and around Mumbai.',

    top: 'Top Places to Visit in Mumbai with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Bandra Kurla Complex (BKC)",
      "description": "Bandra Kurla Complex is Mumbai’s premier financial and commercial district, home to multinational corporations, consulates, global banks, Fortune 500 headquarters, and luxury business hotels. The area includes iconic business towers such as Jio World Centre, Naman Chambers, and The Capital. BKC is the top hotspot for corporate meetings, high-profile events, executive travel, and airport transfers—making it one of the busiest destinations for corporate cab services."
    },
    {
      "title": "Lower Parel Corporate Hub",
      "description": "Lower Parel is Mumbai’s most dynamic corporate zone, combining high-rise office towers like One Indiabulls Centre, Peninsula Business Park, and Lodha World Towers. The area is filled with premium coworking spaces, studios, business hotels, and award-winning restaurants. With its mix of creative agencies, finance companies, and MNCs, Lower Parel demands fast, reliable corporate commuting throughout the day."
    },
    {
      "title": "Nariman Point Business District",
      "description": "Nariman Point is one of India’s oldest and most prestigious business districts, housing corporate headquarters, legal firms, government offices, and international consulates. Overlooking the Marine Drive seafront, it contains iconic commercial towers like Air India Building and Maker Chambers. High-density office traffic makes Nariman Point a prime route for corporate cab travel, especially during peak office hours."
    },
    {
      "title": "Andheri MIDC & SEEPZ",
      "description": "Andheri MIDC and SEEPZ SEZ are major industrial and tech zones in Mumbai, home to IT companies, export houses, manufacturing units, and global service providers. With thousands of employees working across multiple shifts, this zone witnesses high demand for employee transportation, shift-based staff travel, and corporate shuttle services throughout the day."
    },
    {
      "title": "Goregaon Nesco Business Park",
      "description": "Nesco IT Park in Goregaon East has become a major commercial destination with modern office towers, convention centers, and large corporate campuses. It hosts companies in IT, finance, BFSI, and media industries. Its proximity to the Western Express Highway and large employee base makes it one of the most active hubs for corporate cab requirements and executive travel."
    },
    {
      "title": "Powai Hiranandani Business District",
      "description": "Powai’s Hiranandani Business Park is a premium corporate environment featuring modern office complexes, luxury residences, and scenic surroundings. It hosts companies like Nomura, CRISIL, Deloitte, and JP Morgan. The area is known for high-end corporate travel, airport pickups, client meeting routes, and executive chauffeur services due to its professional working crowd."
    },
    {
      "title": "Vikhroli Godrej Business District",
      "description": "Vikhroli is home to the massive Godrej Business Park along with multiple commercial towers, IT campuses, and research facilities. Surrounded by greenery and located close to eastern business zones, it is a preferred location for tech firms and innovation centers. The daily movement of employees and corporate visitors creates consistent demand for premium mobility services."
    },
    {
      "title": "Andheri East Corporate Zone",
      "description": "Andheri East is Mumbai’s largest corporate cluster, packed with commercial towers like Solitaire Corporate Park, Ackruti Star, Times Square, and Hubtown Solaris. Its strategic location near Mumbai Airport makes it a hotspot for business travelers, frequent flyers, and client visits. Corporate cab services play a crucial role in daily commutes, airport drops, and inter-office travel."
    },
    {
      "title": "Malad Mindspace IT Park",
      "description": "Mindspace Malad is one of Mumbai’s biggest IT parks, hosting thousands of professionals working in tech, BPO, and corporate services. With companies like Amazon, Accenture, and JP Morgan operating here, the area runs round-the-clock mobility needs including daily office travel, night shift employee transportation, and executive cab services."
    },
    {
      "title": "Thane Ghodbunder Corporate Belt",
      "description": "Ghodbunder Road in Thane has rapidly grown into a major business corridor with IT parks, commercial complexes, and premium office towers. Corporate hubs like G:Corp, Orion Business Park, and TCS Olympus Centre bring huge employee footfall. It is well-connected to Mumbai, Navi Mumbai, and Thane, making it a high-demand route for corporate taxi and staff transportation services."
    }
  ],


"services": [
{
"name": "Mumbai Employee Transport",
"description": "Mumbai Employee Transport provides reliable and structured transportation solutions for employees working across Mumbai. The service ensures safe, punctual, and comfortable daily commuting with trained drivers, GPS-enabled vehicles, optimized routes, and multi-shift support, catering to office staff, IT parks, and corporate employees."
},
{
"name": "Office Pickup Drop Mumbai",
"description": "Office Pickup Drop Mumbai delivers organized pickup and drop services for office employees and corporate staff. With professional drivers, GPS tracking, multi-passenger vehicles, and structured scheduling, the service ensures timely, secure, and stress-free commuting for daily office travel."
},
{
"name": "Corporate Taxi Mumbai",
"description": "Corporate Taxi Mumbai offers dedicated taxi services for businesses, executives, and corporate employees. The service provides GPS-enabled sedans, professional chauffeurs, structured routes, and timely pickups for office commutes, client visits, and intercity corporate travel across Mumbai."
},
{
"name": "Staff Shuttle Service Mumbai",
"description": "Staff Shuttle Service Mumbai provides multi-passenger shuttle solutions for companies and factories, ensuring safe and organized staff movement. The service features trained drivers, GPS-tracked vehicles, optimized routes, and multi-shift operations for seamless employee transportation."
},
{
"name": "Business Cab Hire Mumbai",
"description": "Business Cab Hire Mumbai delivers professional cab services for corporate travel, client meetings, and inter-office transportation. With well-maintained vehicles, experienced drivers, and GPS tracking, the service ensures comfort, safety, and punctuality for executives and employees."
},
{
"name": "Company Travel Cabs Mumbai",
"description": "Company Travel Cabs Mumbai provides long-term and on-demand corporate taxi solutions for employee commuting and business travel. The service includes dedicated drivers, GPS-enabled vehicles, optimized routes, and structured daily schedules to ensure efficient and reliable transportation."
},
{
"name": "Employee Commute Mumbai",
"description": "Employee Commute Mumbai specializes in daily commuting services for office and IT staff. The service includes trained drivers, GPS tracking, structured routes, multi-shift support, and comfortable vehicles to ensure safe, timely, and efficient transport for employees across Mumbai."
},
{
"name": "Mumbai Corporate Fleet Provider",
"description": "Mumbai Corporate Fleet Provider offers fully managed corporate fleet solutions including sedans, SUVs, and multi-passenger vehicles. The service ensures vehicle maintenance, professional drivers, GPS tracking, and optimized routes, providing seamless and reliable daily commuting for employees and executives."
},
{
"name": "Best Corporate Cabs Mumbai",
"description": "Best Corporate Cabs Mumbai provides premium-quality corporate taxis for employee transport, office commuting, and business travel. The service guarantees punctuality, trained chauffeurs, well-maintained vehicles, GPS tracking, and structured routes for a reliable corporate transportation solution."
},
{
"name": "Affordable Office Cabs Mumbai",
"description": "Affordable Office Cabs Mumbai offers budget-friendly corporate taxi services without compromising on quality or safety. The service provides professional drivers, GPS-monitored vehicles, structured routes, and reliable pickups for daily office commutes at competitive rates."
},
{
"name": "Monthly Corporate Cab Mumbai",
"description": "Monthly Corporate Cab Mumbai delivers long-term taxi rental solutions for businesses requiring consistent employee commuting services. The service includes fixed monthly plans, trained drivers, structured schedules, and GPS-enabled vehicles to ensure reliable and comfortable transportation."
},
{
"name": "Executive Cab Service Mumbai",
"description": "Executive Cab Service Mumbai provides premium sedans and SUVs for corporate executives, VIP clients, and business travel. The service emphasizes comfort, punctuality, professional drivers, and GPS tracking for seamless corporate commuting and client visits."
},
{
"name": "Mumbai Chauffeur Cars",
"description": "Mumbai Chauffeur Cars offers professionally driven vehicles for corporate staff, executives, and VIP clients. The service ensures safety, comfort, punctuality, and discretion, providing a premium commuting experience for office travel, business trips, and airport transfers."
},
{
"name": "Corporate Mobility Mumbai",
"description": "Corporate Mobility Mumbai delivers comprehensive employee mobility solutions for organizations, including fleet management, route optimization, multi-shift transport, and chauffeur-driven vehicles. The service ensures efficient, safe, and comfortable commuting for corporate employees and teams."
},
{
"name": "Mumbai Outstation Corporate Cabs",
"description": "Mumbai Outstation Corporate Cabs provides reliable long-distance transportation for corporate employees, executives, and business teams. The service includes GPS-enabled vehicles, trained drivers, comfortable seating, and optimized routes to ensure safe, timely, and hassle-free outstation travel."
}
],

"tableData": [
["Mumbai Employee Transport", "Office Pickup Drop Mumbai"],
["Corporate Taxi Mumbai", "Staff Shuttle Service Mumbai"],
["Business Cab Hire Mumbai", "Company Travel Cabs Mumbai"],
["Employee Commute Mumbai", "Mumbai Corporate Fleet Provider"],
["Best Corporate Cabs Mumbai", "Affordable Office Cabs Mumbai"],
["Monthly Corporate Cab Mumbai", "Executive Cab Service Mumbai"],
["Mumbai Chauffeur Cars", "Corporate Mobility Mumbai"],
["Mumbai Outstation Corporate Cabs", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Swift Dzire on Rent in Pune for Corporate",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers Swift Dzire rentals for corporate clients in Pune, providing reliable and comfortable transportation for business travel."
  },
  {
    "WhyChooseheading": "Comfortable & Efficient Swift Dzire",
    "WhyChoosedescription": "Our Swift Dzire vehicles are well-maintained, fuel-efficient, and designed for comfortable employee commuting and executive travel."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Travel & Meetings",
    "WhyChoosedescription": "Whether for office commutes, business meetings, or client visits, Swift Dzire ensures convenient and stress-free travel."
  },
  {
    "WhyChooseheading": "Professional Chauffeur Service",
    "WhyChoosedescription": "All rentals come with trained, punctual, and courteous drivers, ensuring safe and disciplined travel for corporate clients."
  },
  {
    "WhyChooseheading": "Punctual & Hassle-Free Service",
    "WhyChoosedescription": "We prioritize timely pickups and drops, providing seamless and dependable corporate transportation."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "We offer hourly, daily, and long-term rental packages, allowing businesses to choose plans suited to their corporate travel needs."
  },
  {
    "WhyChooseheading": "Safe & Sanitized Vehicles",
    "WhyChoosedescription": "All Swift Dzire cars are regularly sanitized, serviced, and equipped with modern safety features for secure corporate commuting."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed smoothly through our easy booking process and reliable coordination for employees and executives."
  }
]






























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Mumbai?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and employees across Mumbai.',
  },
  {
    question: 'What types of corporate cab services are available in Mumbai?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions.',
  },
  {
    question: 'Do you support daily employee commuting for Mumbai companies?',
    answer: 'Yes, we provide daily commute solutions with optimized routes, timely pickups, and customized shift schedules.',
  },
  {
    question: 'How can companies book corporate cab services in Mumbai?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers based on employee strength and corporate requirements.',
  },
  {
    question: 'Can companies avail long-term corporate cab contracts in Mumbai?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible and transparent pricing.',
  },
  {
    question: 'Are safety and tracking features included in corporate cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees?',
    answer: 'Yes, we manage transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in Mumbai?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehta',
    feedback: 'Excellent corporate cab service for our Mumbai office. Punctual, safe, and highly professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Kapoor',
    feedback: 'Reliable and well-managed employee transportation in Mumbai. Pune Corporate Cars India Private Limited handles everything smoothly.',
    rating: 5,
  },
];

























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Mumbai",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-mumbai.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited provides professional corporate cab services in Mumbai, including employee transport, office pickup and drop, business travel, monthly corporate cabs, executive services, and outstation corporate cab solutions. Ensure safe, comfortable, and timely travel for your employees and staff.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "5700", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-mumbai"
  }
};






  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Mumbai | Employee & Business Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited provides professional corporate cab services in Mumbai, including employee transport, office pickup and drop, business travel, monthly corporate cabs, executive services, and outstation corporate cab solutions. Ensure safe, comfortable, and timely travel for your employees and staff."
  />

  <meta
    name="keywords"
    content="Mumbai Employee Transport, Office Pickup Drop Mumbai, Corporate Taxi Mumbai, Staff Shuttle Service Mumbai, Business Cab Hire Mumbai, Company Travel Cabs Mumbai, Employee Commute Mumbai, Mumbai Corporate Fleet Provider, Best Corporate Cabs Mumbai, Affordable Office Cabs Mumbai, Monthly Corporate Cab Mumbai, Executive Cab Service Mumbai, Mumbai Chauffeur Cars, Corporate Mobility Mumbai, Mumbai Outstation Corporate Cabs"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinmumbai;